// score.js

const initState = {
	isExchange: false,	// 当前商品是否是积分商城进来的
	exchangeScore: 0,	// 兑换所需积分
	currentScore: 0,	// 当前用户拥有积分
}

const state = {
	...initState,
	initState(){
        return initState
    }
}

// mutations
const mutations = {
	
	saveIsExchangedState(state, value) {
		state.isExchange = value;
	},

	saveExchangeScoreState(state, value) {
		state.exchangeScore = value;
	},

	saveCurrentScoreState(state, value) {
		state.currentScore = value;
	}
}

export default {
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/score.js